module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("entzO"))).then(() => parcelRequire('ikE14'));